// src/components/ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // A micro-delay ensures React has finished painting the new page
    // before the browser attempts to scroll.
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // Forces an instant snap instead of a slow scroll
      });
    }, 0);
  }, [pathname]);

  return null;
}